import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
    model: any[] = [];
    private accessClaims: string[] = [];
    private readonly menuPermissions: Record<string, string[]> = {
        dashboard: ['Dashboard'],
        customerLeaderboard: ['Customer Leaderboard', 'Overall Customer Leaderboard', 'Overall_Customer_Leaderboard'],
        overallSalesLeaderboard: ['Overall Sales Leaderboard', 'Overall_Sales_Leaderboard'],
        venueManagement: [
            'Venue Management',
            'Venues',
            'Onboarding Venue',
            'Venue Editing',
            'Venue_CreateUpdateVenueBaseProfile',
            'Venue_SearchVenuePagination',
        ],
        teamManagement: [
            'Team Management',
            'User viewing',
            'Onboarding User',
            'User Profile Edit',
            'User_SearchUsersWithPaging',
        ],
        customerManagement: [
            'Customer Management',
            'View Customer',
            'Onboarding Customer',
            'CustomerProfile_SearchCustomerWithPagination',
        ],
        venueLeadManagement: [
            'Venue Lead Management',
            'Venue Leads',
            'Viewing Venue Leads',
            'Viewing Zonal Leads',
            'VenueLead_SearchLeadsWithPagination',
        ],
        subscription: ['Subscription', 'Subscription Management'],
        package: [
            'Package',
            'Package Viewing',
            'Package Creation',
            'Package Editing',
            'Susbcription_SearchSubscriptionsWithPagination',
        ],
        offerManagement: [
            'Offer Management',
            'Offer Viewing',
            'Offer Creation',
            'Offer Editing',
            'GenericOffer_SearchGenericOffersWithPagination',
        ],
        couponManagement: ['Coupon_View'],
        membershipTransfer: ['MembershipTransfer_View'],
        partnerManagement: ['Partner Management'],
        gxPlanner: [
            'GX Planner',
            'GX schedule view',
            'GX Schedule (add)',
            'GxSessions_SearchGXclasswithPagination',
            'GxSessions_SearchGXClassWithPagination',
            'GXSchedule_InsertGxSchedule',
        ],
        partnerStaff: [
            'Partner Staff',
            'Adding Venue staff-Club Manager',
            'Adding Venue staff-MC',
            'Adding Venue staff-PT',
            'Adding Venue staff-HK',
            'VenueStaff_SearchVenueStaffWithPagination',
        ],
        staffAttendance: [
            'Staff Attendance',
            'Staff Attendence',
            'Attendance_SearchAttendanceWithPagination',
            'Attendance_GetStaffAttendanceByDateRange',
            'GetStaffAttendanceByDateRange',
        ],
        rewards: ['Rewards'],
        walletConfig: ['Wallet Config', 'Reward configuration'],
        rewardsConfig: ['Rewards Config', 'Reward view', 'Reward_GetAllRewards'],
        orderAndPayment: [
            'Order and Payment',
            'Order viewing',
            'Create Invoice',
            'Download Invoice',
            'Send Invoice to customer',
            'Order_SearchOrdersWithPagination',
        ],
        contentLibrary: ['Content Library', 'ContentLibrary_View', 'ContentLibrary_SearchContentWithPagination'],
        workout: ['Workout'],
        workoutPlanner: ['Workout Planner', 'workout planner viewing', 'WorkOutPlan_GetWorkOutLevels'],
        exerciseLibrary: ['Exercise Library', 'Viewing Exercise Lib', 'view_ExerciseLibrary'],
        targetManagement: [
            'Target Management',
            'View Target',
            'View Target_Fitzone',
            'View Target_Zones',
            'View Target_Venue',
            'View Target hearchy',
            'Target_GetAllTargets',
        ],
        targetList: ['Target List', 'View Target', 'Target_GetAllTargets'],
        achievedTarget: ['Achieved Target', 'View Target', 'Target_GetAllTargets'],
        paymentSummary: ['Payment Summary', 'Overall Settlement Leaderboard', 'LeaderBoard_getSettlementReport'],
        reports: [
            'Reports',
            'Expiry Report',
            'CheckInMember Report',
            'Check-Away-Member-Report',
            'InActiveMember Report',
            'NewClients Report',
            'Client Attendance Heat map Report',
            'PT Expiry Report',
            'PT New Clients Report',
            'PT Renewal Report',
            'Renewal Report',
            'Revenue Report',
            'Settlement Report',
            'Collection Report',
            'StaffAttendance Report',
            'Staff Birthday And Anniversary Report',
            'Multiclub Clients Report',
            'Commission Report',
            'Overall Settlement Leaderboard',
            'LeaderBoard_getSettlementReport',
        ],
        feedbackManagement: ['Feedback Management', 'Venue Feedback', 'GX Feedback', 'PT Feedback'],
        notificationManagement: [
            'Notification Management',
            'Customer Notification',
            'Partner Notification',
            'Trainer Notification',
        ],
        adminRights: ['Admin-Rights', 'Admin Rights', 'RBAC view', 'RBAC_View'],
        support: ['Support'],
    };
    permissionDashboard = false;
    permissionGetAllVenueLead = false;
    permissionGetAllExistingCustomers = false;
    permissionGetRecentlyAssignedCustomers = false;
    permissionGetTrialCustomers = false;
    permissionGetAllStaff = false;
    permissionPTPackageDefinition = false;
    permissionGetStaffAttendanceByDateRange = false;
    permissionGetAllShift = false;
    permissionGetAllRoster = false;
    permissionGetAllGxSchedule = false;
    Venue_GetVenueBaseProfiles = false;
    permissionAllCustomer = false;
    permissionSubscription = false;
    permissionPackage = false;
    permissionOffer = false;
    permissionAttendance = false;
    permissionOrder = false;
    permissionGx = false;
    userPermission = false;
    rewardPermission = false;
    supportPermission = false;
    workoutPermission = false;
    workoutPlannerPermission = false;
    workoutLibraryPermission = false;
    overallsalesLeaderboard = false;
    overallCustomerLeaderboard = false;
    overallSettlementLeaderBoard = false;
    rewardView = false;
    rbacView = false;
    viewAllTargets = false;

    private getAccessClaims(): string[] {
        try {
            const access = JSON.parse(sessionStorage.getItem('Access') || '[]');
            return Array.isArray(access) ? access.map((item) => String(item)) : [];
        } catch {
            return [];
        }
    }

    private normalizePermission(value: string): string {
        return value.replace(/[\s_-]+/g, '').toLowerCase();
    }

    private hasAccess(...permissions: string[]): boolean {
        const normalizedAccess = this.accessClaims.map((claim) => this.normalizePermission(claim));
        return permissions.some((permission) =>
            normalizedAccess.includes(this.normalizePermission(permission))
        );
    }

    private canAccess(key: string): boolean {
        return this.hasAccess(...(this.menuPermissions[key] || [key]));
    }

    ngOnInit() {
        this.accessClaims = this.getAccessClaims();
        this.permissionDashboard = this.hasAccess(
            'Overall_Sales_Leaderboard',
            'Overall_Venue_Leaderboard',
            'Overall_Customer_Leaderboard',
            'Overall_Settlement_Leaderboard',
            'Zonal_Leaderboard',
            'Custom_Leaderboard_Configuration',
            'Custom_Leaderboard'
        )
            ? true
            : false;
        this.permissionGetAllVenueLead = this.hasAccess(
            'VenueLead_ViewZonalLeads',
            'VenueLead_GetAllVenueLead',
            'VenueLead_AddVenueLead',
            'VenueLead_UpdateVenueLead'
        )
            ? true
            : false;
        this.permissionGetAllExistingCustomers = this.hasAccess(
            'GetAllExistingCustomers'
        )
            ? true
            : false;
        this.permissionGetRecentlyAssignedCustomers = this.hasAccess(
            'GetRecentlyAssignedCustomers'
        )
            ? true
            : false;
        this.permissionGetTrialCustomers = this.hasAccess(
            'GetTrialCustomers'
        )
            ? true
            : false;
        this.permissionGetAllStaff = this.canAccess('partnerStaff')
            ? true
            : false;
        this.permissionPTPackageDefinition = this.hasAccess(
            'GetAllPTPackageDefinition'
        )
            ? true
            : false;
        this.permissionGetStaffAttendanceByDateRange = this.canAccess('staffAttendance')
            ? true
            : false;
        this.permissionGetAllShift = this.hasAccess(
            'VenueStaff_SearchVenueStaffWithPagination'
        )
            ? true
            : false;
        this.permissionGetAllRoster = this.hasAccess('GetAllRoster')
            ? true
            : false;
        this.permissionGetAllGxSchedule = this.canAccess('gxPlanner') || this.hasAccess('GetAllGxSchedule')
            ? true
            : false;

        this.Venue_GetVenueBaseProfiles = this.hasAccess('Venue_CreateUpdateVenueBaseProfile',
            'Venue_DeleteVenueBaseProfile',
            'Zendesk_GetTicketById',
            'Venue_GetVenueBaseProfileByOwner',
            'CommissionSlab_GetCommissionRateByVenue',
            'CommissionRate_InsertUpdate'
        )
            ? true
            : false;
        this.permissionAllCustomer = this.hasAccess(
            'CustomerProfile_Addcustomer',
            'CustomerProfile_Modifycustomer',
            'CustomerProfile_Deletecustomer',
            'Venue_CreateUpdateVenueBaseProfile',
            'Zendesk_GetTicketByUserId',
            'CustomerProfile_GetAllByUserId'
        )
            ? true
            : false;
        this.permissionSubscription = this.hasAccess(
            'Package Viewing',
            'Package Creation',
            'Package Editing',
            'Susbcription_SearchSubscriptionsWithPagination',
            'Susbcription_CreateSubscriptionPackage',
            'Susbcription_UpdateSubscriptionPackage',
            'Susbcription_DeleteSubscriptionPackage',
            'GenericOffer_CreateGenericOffer',
            'GenericOffer_UpdateGenericoffer',
            'GenericOffer_DeleteGenericOffer',
            'GenericOffer_GetOfferById',
            'PT_purchase',
            'Membership_Purchase'
        )
            ? true
            : false;
        this.permissionPackage = this.canAccess('package')
            ? true
            : false;
        this.permissionOffer = this.canAccess('offerManagement')
            ? true
            : false;
        this.permissionAttendance = this.canAccess('staffAttendance')
            ? true
            : false;
        this.permissionOrder = this.hasAccess(
            'Order_CreateInvoice',
            'Order_GetOrderDetailsById',
            'Order_DownloadInvoicePDF',
            'Order_SendInvoiceToCustomer'
        )
            ? true
            : false;
        this.permissionGx = this.hasAccess(
            'VenueStaff_AddNewStaff',
            'Attendance_GetStaffAttendanceSummaryMonthly',
            'GXSchedule_InsertGxSchedule',
            'GXSchedule_GetAllGxSchedule',
            'GXSchedule_GetGxScheduleById',
            'GXSchedule_UpdateGxSchedule',
            'GxSessions_SearchGXClassByLocation',
            'GxSessions_SearchGXClassWithPagination',
            'GxSessions_GetGxSessionsOfACustomer',
            'GxSessions_GetAllCustomersOfASession',
            'GxSessions_GetGxSessionById',
            'GxSessions_InsertGxSessions',
            'GxSessions_UpdateGxSessions',
            'GxSessions_CancelGxSessions',
            'GxSessions_CaptureFeedback',
            'GxSessions_CustomerBookSlot',
            'GxSessions_CancelCustomerBookingOfASession'
        )
            ? true
            : false;
        this.userPermission = this.hasAccess(
            'User_AddUser',
            'User_UpdateUser',
            'User_DeleteUser',
            'User_SearchUsersWithPaging',
            'Attendance_GetStaffAttendanceSummaryMonthly',
            'Role_UpdateRole',
            'Manual_Check-in'
        )
            ? true
            : false;
        this.supportPermission = this.hasAccess(
            'Support',
            'Ticket_History',
            'create_new_ticket'
        ) ? true : false;
        this.workoutPermission = this.hasAccess(
            'AddWorkOutLevelsAndGoalOfCustomer',
            'WorkOutPlan_UploadWorkOutPlanData',
            'AddWorkOutHistoryOfCustomer',
            'WorkOutPlan_GetWorkOutPlanDataByRequest'
        )
        ? true
        : false;
        // this.workoutPermission = this.canAccess('workout') || this.hasAccess(
        //     'WorkOutHistory_SearchWorkOutHistoryWithPagination'
        // )
        //     ? true
        //     : false;
        this.workoutPlannerPermission = this.hasAccess(
            'workoutPlannerPermission'
        )
            ? true
            : false;
        this.workoutLibraryPermission = this.hasAccess(
            'view_ExerciseLibrary'
        )
            ? true
            : false;

        this.overallsalesLeaderboard = this.canAccess('overallSalesLeaderboard')
            ? true
            : false;

        this.overallCustomerLeaderboard = this.canAccess('customerLeaderboard')
            ? true
            : false;
        this.rewardView = this.hasAccess(
            'Reward_AddReward',
            'Reward_GetAllRewards'
        ) || this.canAccess('walletConfig') || this.canAccess('rewardsConfig')
            ? true
            : false;

        this.rbacView = this.hasAccess(
            'RBAC_Settings',
            'RBAC_View'
        )
            ? true
            : false;
        this.viewAllTargets = this.canAccess('targetManagement')
            ? true
            : false;
        this.overallSettlementLeaderBoard = this.canAccess('paymentSummary')
            ? true
            : false;

        this.model = [
            {
                icon: 'pi pi-th-large',
                items: [
                    {
                        label: 'My Dashboard',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/home/dashboard'],
                        show: this.permissionDashboard,
                    },
                    {
                        label: 'Customer Leaderboard',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/home/dashboard/customer-leaderboard'],
                        show: this.overallCustomerLeaderboard,
                    },
                    {
                        label: 'Overall Sales Leaderboard',
                        icon: 'pi pi-fw pi-chart-bar',
                        routerLink: ['/home/dashboard/overall-sales-leaderboard'],
                        show: this.overallsalesLeaderboard,
                    },
                    {
                        label: 'Venues',
                        icon: 'pi pi-fw pi-map',
                        routerLink: ['/home/venue-management/venues'],
                        show: this.Venue_GetVenueBaseProfiles,
                    },
                    {
                        label: 'Team Management',
                        icon: 'pi pi-sitemap',
                        routerLink: ['/home/user-management/users'],
                        show: this.userPermission,
                    },
                    {
                        label: 'Customer Management',
                        icon: 'pi pi-fw pi-users',
                        routerLink: ['/home/customer-management/customers'],
                        show: this.permissionAllCustomer,
                    },
                    {
                        label: 'Venue Leads',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/home/venue-leads'],
                        show: this.permissionGetAllVenueLead,
                    },
                    {
                        label: 'Lead Management',
                        icon: 'pi pi-fw pi-inbox',
                        routerLink: ['/home/lead-management'],
                        show: this.permissionGetAllVenueLead,
                    },
                    // {
                    //     label: 'Online Leads',
                    //     icon: 'pi pi-fw pi-image',
                    //     routerLink: ['/home/online-lead-management'],
                    //     show: this.permissionGetAllVenueLead,
                    // },
                   
                    {
                        label: 'Subscription',
                        icon: 'pi pi-credit-card',
                        items: [
                            {
                                label: 'Package',
                                icon: 'pi pi-box',
                                routerLink: [
                                    '/home/subscription-management/package-list',
                                ],
                                show: this.permissionPackage,
                            },
                            {
                                label: 'Offer Management',
                                icon: 'pi pi-tag',
                                routerLink: [
                                    '/home/subscription-management/generic-offer-list',
                                ],
                                show: this.permissionOffer,
                            },
                        ],

                        show: this.hasAccess(
                            'Susbcription_CreateSubscriptionPackage',
                            'Susbcription_UpdateSubscriptionPackage',
                            'Susbcription_DeleteSubscriptionPackage',
                            'Susbcription_SearchSubscriptionsWithPagination',
                            'GenericOffer_CreateGenericOffer',
                            'GenericOffer_UpdateGenericoffer',
                            'GenericOffer_DeleteGenericOffer',
                            'GenericOffer_GetOfferById',
                            'PT_purchase',
                            'Membership_Purchase'
                        ) || this.permissionPackage || this.permissionOffer,
                    },
                    {
                        label: 'Coupon Management',
                        icon: 'pi pi-fw pi-percentage',
                        routerLink: ['/home/coupon-management'],
                        show: this.canAccess('couponManagement'),
                    },
                    {
                        label: 'Membership Transfers',
                        icon: 'pi pi-fw pi-sync',
                        routerLink: ['/home/membership-transfer'],
                        show: this.canAccess('membershipTransfer'),
                    },
                    {
                        label: 'Partner Management',
                        icon: 'pi pi-fw pi-user-edit',
                        items: [
                            {
                                label: 'GX Planner',
                                icon: 'pi pi-fw pi-calendar',
                                routerLink: ['/home/gx-planner'],
                                show: this.permissionGx,
                            },
                            {
                                label: 'Partner Staff',
                                icon: 'pi pi-fw pi-users',
                                routerLink: [
                                    '/home/partner-portal-management/staff-management',
                                ],
                                show: this.permissionGetAllStaff,
                            },
                            {
                                label: 'Staff Attendance',
                                icon: 'pi pi-fw pi-check',
                                routerLink: ['/home/staff-attendance'],
                                show: this.permissionAttendance,
                            },
                        ],
                        show: this.hasAccess(
                             'Attendance_GetStaffAttendanceByDateRange',
                             'Attendance_GetStaffAttendanceSummaryMonthly'
                        ) || this.permissionGx || this.permissionGetAllStaff || this.permissionAttendance,
                    },
                    {
                        label: 'Rewards',
                        icon: 'pi pi-fw pi-gift',
                        items: [
                            {
                                label: 'Wallet Config',
                                icon: 'pi pi pi-fw pi-wallet',
                                routerLink: [
                                    '/home/rewards-management/wallet',
                                ],
                                show: this.canAccess('walletConfig'),
                            },
                            {
                                label: 'Rewards Config',
                                icon: 'pi pi pi-fw pi-gift',
                                routerLink: [
                                    '/home/rewards-management/rewards',
                                ],
                                show: this.canAccess('rewardsConfig'),
                            }
                        ],

                        show: this.rewardView,
                    },

                    {
                        label: 'Order and Payment',
                        icon: 'pi pi-fw pi-wallet',
                        routerLink: ['/home/order-and-payment-management'],
                        show: this.permissionOrder,
                    },
                    {
                        label: 'Content Library',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/home/content-library/libraries-list'],
                        show: this.canAccess('contentLibrary'),
                    },

                    {
                        icon: 'pi pi-inbox',
                        label: 'Workout',
                        show: this.hasAccess(
                            'AddWorkOutLevelsAndGoalOfCustomer',
                            'WorkOutPlan_UploadWorkOutPlanData',
                            'AddWorkOutHistoryOfCustomer',
                            'WorkOutPlan_GetWorkOutPlanDataByRequest'
                        ) || this.workoutPlannerPermission || this.workoutLibraryPermission,
                        items: [
                            {
                                label: 'Workout Planner',
                                icon: 'pi pi-fw pi-sitemap',
                                routerLink: [
                                    '/home/workout-management/workout-planner',
                                ],
                                show: this.workoutPlannerPermission,
                            },
                            {
                                label: 'Exercise Library',
                                icon: 'pi pi-fw pi-book',
                                routerLink: [
                                    '/home/workout-management/excercise-library',
                                ],
                                show: this.workoutLibraryPermission,
                            },
                        ],
                    },
                    {
                        label: 'Target Management',
                        icon: 'pi pi-arrow-circle-up',
                        // routerLink: ['/home/target-management'],
                        show: this.viewAllTargets || this.hasAccess(
                            'Target_GetAllTargets',
                            'Target_GetTargetById',
                            'Add Target_sales_Zone',
                            'Add Target_sales_Venue',
                            'Add Target_sales_Venue_MC',
                            'Add Target_PT_Venue',
                            'Add Target_PT_Venue_PT',
                            'Target_DeleteTargets',
                            'Target_UpdateTargets',
                            'permissionAddNewTarget'
                        ) || this.canAccess('achievedTarget'),
                        items: [{
                            label: "Target List",
                            icon: 'pi pi-chart-bar',
                            routerLink: [
                                '/home/target-management'
                            ],
                            show: this.canAccess('targetList')
                        },
                        {
                            label: "Achieved Target",
                            icon: 'pi pi-check-circle',
                            routerLink: [
                                '/home/target-management/achieved-target'
                            ],
                            show: this.canAccess('achievedTarget')
                        }
                        ]
                    },

                     {
                        label: 'Payment Summary',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['/home/settlement-invoice'],
                        show: this.overallSettlementLeaderBoard,
                    },
                    {
                        label: "Reports",
                        icon: "pi pi-fw pi-chart-bar",
                        show: this.canAccess('reports'),
                        items: [
                            {
                                label: "Expiry Report",
                                icon: "pi pi-fw pi-calendar",
                                routerLink: ["/home/reports/ExpiryReport"],
                                show: this.hasAccess('Expiry Report', 'Reports')
                            },

                            {
                                label: "CheckInMember Report",
                                icon: "pi pi-fw pi-users",
                                routerLink: ["/home/reports/CheckInMember"],
                                show: this.hasAccess('CheckInMember Report', 'Reports')
                            },
                            //Check-Away-Member-Report
                             {
                                label: "Check-Away-Member-Report",
                                icon: "pi pi-chevron-circle-right",
                                routerLink: ["/home/reports/Check-Away-Member-Report"],
                                show: this.hasAccess('Check-Away-Member-Report', 'Reports')
                            },
                            {
                                label: "InActiveMember Report",
                                icon: "pi pi-fw pi-user-minus",
                                routerLink: ["/home/reports/InActiveMember"],
                                show: this.hasAccess('InActiveMember Report', 'Reports')
                            },
                            {
                                label: "NewClients Report",
                                icon: "pi pi-fw pi-user-plus",
                                routerLink: ["/home/reports/NewClients"],
                                show: this.hasAccess('NewClients Report', 'Reports')
                            },
                            {
                                label: "Client Attendance Heat map Report",
                                icon: "pi pi-fw pi-check-circle",
                                routerLink: ["/home/reports/ClientAttendance"],
                                show: this.hasAccess('Client Attendance Heat map Report', 'Reports')
                            },
                            {
                                label: "PT Expiry Report",
                                icon: "pi pi-fw pi-calendar",
                                routerLink: ["/home/reports/GetReportwithVenue", { dashboardId: 62 }],
                                show: this.hasAccess('PT Expiry Report', 'Reports')
                            },
                            {
                                label: "PT New Clients Report",
                                icon: "pi pi-fw pi-users",  // New icon for clients
                                routerLink: ["/home/reports/GetReportwithVenue", { dashboardId: 65 }],
                                show: this.hasAccess('PT New Clients Report', 'Reports')
                            },
                            {
                                label: "PT Renewal Report",
                                icon: "pi pi-fw pi-refresh",  // Icon for renewal
                                routerLink: ["/home/reports/GetReportwithVenue", { dashboardId: 66 }],
                                show: this.hasAccess('PT Renewal Report', 'Reports')
                            },
                            {
                                label: "Renewal Report",
                                icon: "pi pi-fw pi-refresh",  // Different icon for renewal
                                routerLink: ["/home/reports/GetReportwithVenue", { dashboardId: 64 }],
                                show: this.hasAccess('Renewal Report', 'Reports')
                            },
                            {
                                label: "Renewal Window Report",
                                icon: "pi pi-fw pi-calendar-plus",
                                routerLink: ["/home/reports/Renewal-Window-Report"],
                                // No dedicated backend permission yet — visible to
                                // anyone who can already see the Reports menu.
                                show: this.canAccess('reports')
                            }
                            ,
                            {
                                label: "Revenue Report",
                                icon: "pi pi-fw pi-chart-line",
                                routerLink: ["/home/reports/Revenue"],
                                show: this.hasAccess('Revenue Report', 'Reports')
                            },
                            {
                                label: "Settlement Report",
                                icon: "pi pi-check-square",
                                routerLink: ["/home/reports/Settlement"],
                                show: this.overallSettlementLeaderBoard
                            },
                            {
                                label: "Collection Report", // Formerly Settlement Report
                                icon: "pi pi-fw pi-wallet",
                                routerLink: ["/home/reports/Collection-Report"],
                                show: this.overallSettlementLeaderBoard
                            },
                            {
                                label: "Sales Report",
                                icon: "pi pi-fw pi-shopping-cart",
                                routerLink: ["/home/reports/Sales-Report"],
                                show: this.overallSettlementLeaderBoard
                            },
                            {
                                label: "StaffAttendance Report",
                                icon: "pi pi-fw pi-id-card",
                                routerLink: ["/home/reports/StaffAttendance", { dashboardId: 77 }],
                                show: this.hasAccess('StaffAttendance Report', 'Reports')
                            },
                           
                            {
                                label: "Staff Birthday And Anniversary Report",
                                icon: "pi pi-fw pi-map-marker", // Location pin icon for venue-specific reports
                                routerLink: ["/home/reports/ReportByVenue", { dashboardId: 70 }],
                                show: this.hasAccess('Staff Birthday And Anniversary Report', 'Reports')
                            },
                            
                            {
                                label: "Multiclub Clients Report",
                                icon: "pi pi-fw pi-discord", // Location pin icon for venue-specific reports
                                routerLink: ["/home/reports/ReportByVenue", { dashboardId: 79 }],
                                show: this.hasAccess('Multiclub Clients Report', 'Reports')
                            },
                            {
                                label: "Commission Report",
                                icon: "pi pi-fw pi-money-bill", // Location pin icon for venue-specific reports
                                routerLink: ["/home/reports/Commission-Report"],
                                show: this.hasAccess('Commission Report', 'Reports')
                            },
                            {
                                label: "Lead Attribution Report",
                                icon: "pi pi-fw pi-sitemap",
                                routerLink: ["/home/reports/Lead-Attribution"],
                                // No dedicated backend permission yet — visible to
                                // anyone who can already see the Reports menu.
                                show: this.canAccess('reports')
                            },
                            {
                                label: "Fitcoins Report",
                                icon: "pi pi-fw pi-star",
                                routerLink: ["/home/reports/Fitcoins-Report"],
                                // No dedicated backend permission yet — visible to
                                // anyone who can already see the Reports menu.
                                show: this.canAccess('reports')
                            },
                            {
                                label: "Coupon Purchases Report",
                                icon: "pi pi-fw pi-ticket",
                                routerLink: ["/home/reports/Coupon-Report"],
                                // No dedicated backend permission yet — visible to
                                // anyone who can already see the Reports menu.
                                show: this.canAccess('reports')
                            }

                        ],
                    },
                    {
                        label: 'Feedback Management',
                        icon: 'pi pi-star',
                        // routerLink: ['/home/target-management'],
                        show: this.canAccess('feedbackManagement'),
                        items: [
                            {
                                label: "Venue Feedback",
                                icon: 'pi pi-building',
                                routerLink: ["/home/feedback-management/venue-feedback"],
                                show: this.hasAccess(
                                    'feedback_GetUnHappyUsersCallOuts',
                                    'feedback_GetHappyUsersCallOuts',
                                    'feedback_GetUsersRatingSplit',
                                    'feedback_GetUsersDailyRatingTrend',
                                    'feedback_GetUsersFeedback',
                                    'feedback_AddUserFeedback',
                                    'feedback_ModifyUserFeedback',
                                    'feedback_GetPersonalTrainerFeedback'
                                )
                            },
                            {
                                label: "GX Feedback",
                                icon: 'pi pi-box',
                                routerLink: ["/home/feedback-management/gx-feedback"],
                                show: this.hasAccess(
                                    'feedback_GetUnHappyUsersCallOuts',
                                    'feedback_GetHappyUsersCallOuts',
                                    'feedback_GetUsersRatingSplit',
                                    'feedback_GetUsersDailyRatingTrend',
                                    'feedback_GetUsersFeedback',
                                    'feedback_AddUserFeedback',
                                    'feedback_ModifyUserFeedback',
                                    'feedback_GetPersonalTrainerFeedback'
                                )
                            },
                            {
                                label: "PT Feedback",
                                icon: 'pi pi-cog',
                                routerLink: ["/home/feedback-management/pt-feedback"],
                                show: this.hasAccess(
                                    'feedback_GetUnHappyUsersCallOuts',
                                    'feedback_GetHappyUsersCallOuts',
                                    'feedback_GetUsersRatingSplit',
                                    'feedback_GetUsersDailyRatingTrend',
                                    'feedback_GetUsersFeedback',
                                    'feedback_AddUserFeedback',
                                    'feedback_ModifyUserFeedback',
                                    'feedback_GetPersonalTrainerFeedback'
                                )
                            }
                        ]
                    },

                    {
                        label: 'Notification Management',
                        icon: 'pi pi-bell',
                        // routerLink: ['/home/target-management'],
                        show: this.canAccess('notificationManagement'),
                        items: [
                            {
                                label: "Customer Notification",
                                icon: 'pi pi-user',
                                routerLink: ["/home/notification-management/customer-notifications"],
                                show: this.hasAccess('Customer Notification')
                            },
                            {
                                label: "Partner Notification",
                                icon: 'pi pi-users',
                                routerLink: ["/home/notification-management/partner-notifications"],
                                show: this.hasAccess('Partner Notification')
                            },
                            {
                                label: "Trainer Notification",
                                icon: 'pi pi-bolt',
                                routerLink: ["/home/notification-management/trainer-notifications"],
                                show: this.hasAccess('Trainer Notification')
                            }
                        ]
                    },

                    {
                        label: 'Admin-Rights',
                        icon: 'pi pi-arrow-circle-up',
                        routerLink: ['/home/admin-rights'],
                        // show: this.permissionOrder,
                        show: this.rbacView
                    },
                    {
                        label: 'Support',
                        icon: 'pi pi-fw pi-comments',
                        routerLink: ['/home/support'],
                        show: this.supportPermission,
                    },
                ],
            },
        ];
    }
}
